<template>
  <div class="vx-row mb-6">
    <div class="vx-col w-full">
      <label class="vs-input--label">Delivery Model</label>
      <br />
      <ul class="centerx">
        <li>
          <vs-radio v-model="mutableValue" vs-value="Delivery Business Partner">Business Partner</vs-radio>&nbsp;&nbsp;&nbsp;
        </li>
        <li>
          <vs-radio v-model="mutableValue" vs-value="Delivery End Customer">End Customer</vs-radio>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      mutableValue: ""
    };
  },
  mounted() {
    if (this.value) {
      this.mutableValue = this.value;
    }
  },
  watch: {
    mutableValue(val) {
      this.$emit("data", val);
    },
    value(val) {
      this.mutableValue = val;
    }
  }
};
</script>